module.exports = __webpack_public_path__ + "static/media/lv_sparkling_dark_cherry.c700fc53.png";